import Vue from 'vue';
import Vuex from 'vuex';

import {
  state,
  getters,
  actions,
  mutations,
} from './root';

// modules
import user from './modules/user';

Vue.use(Vuex);

export default new Vuex.Store({
  state,
  getters,
  actions,
  mutations,

  modules: {
    user
  },

  strict: true,
});
